import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function   Kiacarencecabserviceinmumbai() {



  const cardData = {
    keyword: " Kia Carens Cab Service in Mumbai ",


"headingDescription": "Royal Route Cab offers comfortable and premium Kia Carens cab service in Mumbai, providing a perfect travel solution for families, corporate groups, airport transfers, and outstation journeys. The Kia Carens is a modern 6 to 7 seater MPV known for its stylish design, spacious interiors, advanced features, and smooth ride quality, making it ideal for long-distance and city travel. Our well-maintained Carens vehicles come with professional drivers to ensure a safe, punctual, and stress-free journey across Mumbai and nearby destinations. Kia Carens cab pricing in Mumbai typically starts from around ₹15 to ₹18 per km for outstation travel and flexible hourly packages for local trips depending on distance and duration. We offer one-way, round trip, and customized travel options with transparent pricing and no hidden charges. With 24/7 availability and easy booking, Royal Route Cab is your trusted choice for Kia Carens cab service in Mumbai.",

"topPlaces": [
  {
    "title": "Kia Carens Cab Service in Mumbai",
    "description": "Kia Carens cab service in Mumbai is a popular choice for families, corporate travelers, and tourists seeking a comfortable and premium travel experience. With spacious interiors and modern features, it is ideal for local travel, airport transfers, and outstation trips."
  },
  {
    "title": "Kia Carens Rental Service Mumbai",
    "description": "Kia Carens rental services in Mumbai offer reliable and comfortable transportation for business trips, family vacations, weddings, and sightseeing tours. The vehicle combines style, comfort, and practicality for every journey."
  },
  {
    "title": "Kia Carens with Driver Mumbai",
    "description": "Kia Carens with driver services in Mumbai provide a convenient and stress-free travel experience. Professional chauffeurs ensure safe and smooth transportation for city travel, airport transfers, and long-distance journeys."
  },
  {
    "title": "Mumbai Airport Kia Carens Cab Service",
    "description": "Mumbai Airport Kia Carens cab services are preferred by travelers looking for comfortable airport transfers. The vehicle offers ample seating and luggage space, making pickups and drop-offs convenient and hassle-free."
  },
  {
    "title": "Luxury Kia Carens Cab Mumbai",
    "description": "Luxury Kia Carens cab services in Mumbai provide premium transportation with modern interiors, comfortable seating, and advanced features. They are ideal for business travel, special occasions, and family outings."
  },
  {
    "title": "Kia Carens for Outstation Trips from Mumbai",
    "description": "Kia Carens is an excellent choice for outstation trips from Mumbai to destinations such as Lonavala, Pune, Nashik, Mahabaleshwar, and Shirdi. Its spacious cabin and smooth ride ensure a comfortable travel experience."
  },
  {
    "title": "Corporate Kia Carens Cab Service Mumbai",
    "description": "Corporate Kia Carens cab services in Mumbai cater to business professionals attending meetings, conferences, and corporate events. The vehicle offers a professional and comfortable travel environment."
  },
  {
    "title": "Kia Carens for Family Travel Mumbai",
    "description": "Families traveling in Mumbai often choose Kia Carens cab services due to the vehicle’s spacious seating, safety features, and comfortable interiors. It is suitable for local sightseeing and weekend getaways."
  },
  {
    "title": "Affordable Kia Carens Cab Mumbai",
    "description": "Affordable Kia Carens cab services in Mumbai provide a cost-effective transportation option without compromising on comfort and quality. They are suitable for daily travel, airport transfers, and family trips."
  },
  {
    "title": "Best Kia Carens Cab Service Mumbai",
    "description": "The best Kia Carens cab services in Mumbai focus on customer satisfaction, safety, and reliable transportation. They are widely used for airport transfers, corporate travel, family outings, and outstation journeys."
  }
],






services: [
  {
    name: "Kia Carens Cab Service Mumbai",
    description: "Kia Carens cab service Mumbai offers a premium and spacious travel experience for families and corporate travelers. This modern MPV provides comfortable seating, advanced features, and smooth performance for city and outstation journeys. Professional drivers ensure safety and punctuality. It guarantees a comfortable and stylish travel experience."
  },
  {
    name: "Kia Carens Rental Mumbai",
    description: "Kia Carens rental Mumbai provides flexible travel solutions with a premium MPV suitable for group travel. This service is ideal for family trips, business travel, and airport transfers. Clean vehicles and experienced drivers enhance comfort. It ensures a smooth journey."
  },
  {
    name: "Kia Carens Taxi Mumbai",
    description: "Kia Carens taxi Mumbai offers convenient and comfortable transportation with spacious interiors and modern features. This service is ideal for local travel, airport transfers, and outstation trips. Professional drivers ensure safe travel. It guarantees a pleasant experience."
  },
  {
    name: "Carens Cab Booking Mumbai",
    description: "Carens cab booking Mumbai allows customers to reserve premium MPV rides easily with flexible options. Travelers can choose pickup location, timing, and travel plan. Instant confirmation ensures availability. It simplifies travel planning."
  },
  {
    name: "Kia Carens Hire Mumbai",
    description: "Kia Carens hire Mumbai offers convenient rental options for comfortable and spacious travel. This service is ideal for family outings, corporate trips, and events. Well-maintained vehicles ensure reliability. It ensures a relaxed journey."
  },
  {
    name: "Kia Carens Price Mumbai",
    description: "Kia Carens price Mumbai varies based on trip type, distance, and duration. Transparent pricing ensures no hidden charges. Customers can choose flexible packages based on travel needs. It helps in planning travel efficiently. It ensures value for money."
  },
  {
    name: "Kia Carens Taxi Fare Mumbai",
    description: "Kia Carens taxi fare Mumbai is designed to be competitive for premium MPV travel. Fare depends on route, usage, and duration. Customers receive clear pricing details before booking. It ensures cost-effective travel."
  },
  {
    name: "Kia Carens One Way Cab Mumbai",
    description: "Kia Carens one way cab Mumbai is a cost-effective option for travelers needing a single-side drop. This service eliminates return charges and offers flexible travel timings. Ideal for airport and outstation travel. It ensures smooth and economical travel."
  },
  {
    name: "Kia Carens Round Trip Cab Mumbai",
    description: "Kia Carens round trip cab Mumbai is ideal for travelers planning return journeys. This service includes pickup, drop, waiting time, and return travel. Flexible schedules make it convenient. Suitable for family trips and corporate travel. It ensures comfort and efficiency."
  },
  {
    name: "Cheap Kia Carens Rental Mumbai",
    description: "Cheap Kia Carens rental Mumbai offers budget-friendly options for premium travel without compromising comfort. This service is ideal for cost-conscious travelers. Transparent pricing ensures no hidden charges. It ensures economical travel."
  },
  {
    name: "Best Kia Carens Cab Service Mumbai",
    description: "Best Kia Carens cab service Mumbai ensures top-quality vehicles and professional drivers for a smooth travel experience. This service focuses on comfort, safety, and customer satisfaction. It guarantees a reliable journey."
  },
  {
    name: "Kia Carens Airport Cab Mumbai",
    description: "Kia Carens airport cab Mumbai provides spacious and comfortable airport transfers for families and groups. This service ensures timely pickup and drop at terminals. Professional drivers ensure safe travel. It guarantees a stress-free airport experience."
  },
  {
    name: "Kia Carens Outstation Cab Mumbai",
    description: "Kia Carens outstation cab Mumbai offers reliable long-distance travel with spacious seating and modern features. This service is ideal for family vacations and group trips. Vehicles are maintained for highway performance. It ensures a safe and enjoyable journey."
  }
],

tableData: [
  ["Kia Carens Cab Service Mumbai", "Kia Carens Rental Mumbai"],
  ["Kia Carens Taxi Mumbai", "Carens Cab Booking Mumbai"],
  ["Kia Carens Hire Mumbai", "Kia Carens Price Mumbai"],
  ["Kia Carens Taxi Fare Mumbai", "Kia Carens One Way Cab Mumbai"],
  ["Kia Carens Round Trip Cab Mumbai", "Cheap Kia Carens Rental Mumbai"],
  ["Best Kia Carens Cab Service Mumbai", "Kia Carens Airport Cab Mumbai"],
  ["Kia Carens Outstation Cab Mumbai", "Kia Carens Cab Service Mumbai"]
],


whychoose: [
  {
    WhyChooseheading: "Comfortable Kia Carens Cab Service in Mumbai",
    WhyChoosedescription: "Royal Route Cabs offers premium Kia Carens cab service in Mumbai, ideal for family travel, airport transfers, and outstation trips."
  },
  {
    WhyChooseheading: "Spacious & Premium MPV Experience",
    WhyChoosedescription: "Kia Carens provides comfortable seating, modern interiors, and ample space for 6-7 passengers, ensuring a relaxing journey."
  },
  {
    WhyChooseheading: "Professional & Experienced Drivers",
    WhyChoosedescription: "Our drivers are well-trained and experienced in Mumbai routes, ensuring safe and hassle-free travel."
  },
  {
    WhyChooseheading: "Transparent Pricing with No Hidden Charges",
    WhyChoosedescription: "Royal Route Cabs provides clear pricing for Kia Carens service including all charges with no hidden costs."
  },
  {
    WhyChooseheading: "24/7 Cab Availability",
    WhyChoosedescription: "Our Kia Carens cab service in Mumbai is available 24/7 for flexible travel anytime."
  },
  {
    WhyChooseheading: "Clean & Well-Maintained Vehicles",
    WhyChoosedescription: "All Kia Carens vehicles are regularly serviced, sanitized, and maintained for a comfortable travel experience."
  },
  {
    WhyChooseheading: "Local & Outstation Travel Options",
    WhyChoosedescription: "Book Kia Carens for local Mumbai travel, airport pickup-drop, or outstation trips with customized packages."
  },
  {
    WhyChooseheading: "Trusted Premium Cab Service",
    WhyChoosedescription: "Royal Route Cabs is trusted by customers for reliable Kia Carens cab service in Mumbai with punctual drivers and smooth service."
  }
]

};

const faqData = [
  { question: "Do you provide Kia Carens cab service in Mumbai?", answer: "Yes, Royal Route Cabs offers Kia Carens cab services in Mumbai for local and outstation travel." },
  { question: "How many passengers can travel in Kia Carens?", answer: "Kia Carens can comfortably seat 6 to 7 passengers." },
  { question: "Is Kia Carens suitable for long-distance travel?", answer: "Yes, Kia Carens is ideal for both city and long-distance travel due to its comfort and space." },
  { question: "Is cab service available 24 hours?", answer: "Yes, our Kia Carens cab service operates 24/7." },
  { question: "Do you provide driver with Kia Carens?", answer: "Yes, all bookings include professional drivers." },
  { question: "Is pricing transparent?", answer: "Yes, we provide clear pricing with no hidden charges." },
  { question: "Do you provide airport pickup with Kia Carens?", answer: "Yes, we offer Mumbai airport pickup and drop services with Kia Carens." },
  { question: "Can I book for one-way trips?", answer: "Yes, we provide one-way and round-trip booking options." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended for better availability." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Vivek Sharma",
    feedback: "Kia Carens cab service in Mumbai from Royal Route Cabs was very comfortable and spacious. The ride quality was smooth and perfect for family travel.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Pooja Deshmukh",
    feedback: "Excellent experience booking Kia Carens in Mumbai. The vehicle was clean, modern, and the journey felt safe and relaxing throughout.",
    rating: 5
  }
];














  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman taxi", link: "Mumbai-to-Daman-Taxi" },
    { place: "/images/keyword/26.jpg", text: "Mumbai to Vapi cab", link: "Mumbai-to-Vapi-Cab" },
    { place: "/images/keyword/27.jpg", text: "Mumbai to Bangalore cab", link: "Mumbai-to-Bangalore-Cab" }
  ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Kia Carens Cab Service in Mumbai",
  "image": "https://www.royalroutecabs.com/assets/images/kia-carens-cab-service-mumbai.jpg", // replace if needed
  "description": "Book Kia Carens cab service in Mumbai with Royal Route Cabs for spacious, comfortable, and family-friendly travel. Ideal for airport transfers, outstation trips, and long-distance journeys with 24x7 reliable service.",
  "brand": {
    "@type": "Brand",
    "name": "Royal Route Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "3200",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "13", // per km approx starting (adjust if needed)
    "availability": "https://schema.org/InStock",
    "url": "https://www.royalroutecabs.com/kia-carens-cab-service-mumbai"
  }
};








  return (
    <div>

<Helmet>
  <title>Kia Carens Cab Service in Mumbai | Call:- +91 9529877342 | Best Outstation Cab Service</title>

  <meta
    name="description"
    content="Book Kia Carens cab service in Mumbai with Royal Route Cabs. Spacious 6/7-seater car for airport, local, and outstation travel. Safe, comfortable & affordable 24x7 service."
  />

  <meta
    name="keywords"
    content="kia carens cab service mumbai, kia carens rental mumbai, kia carens taxi mumbai, carens cab booking mumbai, kia carens hire mumbai, kia carens price mumbai, kia carens taxi fare mumbai, kia carens one way cab mumbai, kia carens round trip cab mumbai, cheap kia carens rental mumbai, best kia carens cab service mumbai, kia carens airport cab mumbai, kia carens outstation cab mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="text-center">{cardData.keyword}</h1>
          </div>
        </div>
      </div>














      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/46.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Royal Route Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


          <div className="keyword-grid">
  {cardData.tableData.flat().map((keyword, index) => (
    <div key={index} className="keyword-item">
      <span className="keyword-bullet">-</span>
      {keyword}
    </div>
  ))}
</div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title text-white">
                  Why Choose <span>Royal Route Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Royal Route Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529877342" className="pc-call">+91 9529877342</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529877342"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529877342" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@royalroutecabs.com" className="pc-email">
                      booking@royalroutecabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Royal Route Cab</strong><br />
                      Shop Number 57, Prabhat Colony Opp. Panbai International School Vimladevi Road,Santacruz(E) Mumbai Maharashtra-400055.


                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Kiacarencecabserviceinmumbai;